import { render, staticRenderFns } from "./AdminBatchInquiryReport.vue?vue&type=template&id=fc8ee36a"
import script from "./AdminBatchInquiryReport.vue?vue&type=script&lang=js"
export * from "./AdminBatchInquiryReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports